module.exports = __webpack_public_path__ + "media/img/services/services-card-img4-4d1f1de0cafa73aafe720e05f907958f.svg";